<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <material-card icon="mdi-content-copy" :title="title" :text="text">    
                    <v-form id="form" ref="form">
                        <v-container py-0>
                            <v-layout wrap>
                                <v-flex xs12 md12>
                                    <range-date-picker v-model="dataSelecionada" :required="true" :requiredText="selecionePeriodo" :label="periodo">
                                    </range-date-picker>
                                </v-flex>  

                                <v-flex xs12 md6>
                                    <v-select :label="cboPais" :items="lista.pais" return-object v-model="paisComputed"
                                        item-value="id" item-text="nome" :no-data-text="cboPaisSemDados"
                                        required :rules="rules.pais"></v-select>
                                </v-flex>   

                                <v-flex xs12 md6>
                                    <v-text-field :label="labelJobReqId" v-model="jobReqId"/>
                                </v-flex>                                  

                                <v-flex xs12 md6 v-show="pais != null">
                                    <v-text-field :label="labelDocumento" v-mask="mascaraDocumento" v-model.trim="documento"/>
                                </v-flex> 

                                <v-flex xs12 md6>
                                    <v-select multiple :label="status" :items="lista.statusIntegracao" return-object v-model="listaStatus"
                                        item-value="id" item-text="descricao"></v-select>
                                </v-flex>                                    

                                <v-flex xs12 md6>
                                    <v-text-field :label="labelPrimeiroNome" v-model.trim="primeiroNome"/>
                                </v-flex>  

                                <v-flex xs12 md6>
                                    <v-text-field :label="labelUltimoNome" v-model.trim="ultimoNome"/>
                                </v-flex>                                                                                                                                                                                                                

                                <v-flex xs12 md12 class="d-flex justify-center">
                                    <v-btn class="danger" @click="btnLimpar_OnClick">
                                        <v-icon left>mdi-restore</v-icon> 
                                        {{clear}}
                                    </v-btn>                          

                                    <v-btn class="success" @click="btnPesquisar_OnClick">
                                        <v-icon left>mdi-filter</v-icon> 
                                        {{search}}
                                    </v-btn>                                                                                
                                </v-flex>   
                            </v-layout>
                        </v-container>
                    </v-form> 
                    <br/> 

                    <v-data-table :headers="colunas" :items="resultado" class="elevation-1" :footer-props="dataFooter">
                        <template v-slot:[`item.dataCadastro`]="{ item }">
                            {{formatUtcToLocal(item.dataCadastro)}}                              
                        </template>       

                        <template v-slot:[`item.dataAdmissaoReal`]="{ item }">
                            {{formatUtcDate(item.dataAdmissaoReal)}}                              
                        </template>                                                    
                        
                        <template v-slot:[`item.status`]="{ item }">
                            <v-tooltip bottom v-if="item.status != null && item.status.codigoUnico == 'PEND.APROV'">
                                <template v-slot:activator="{ on }">
                                    <v-icon :color="item.status.passou24h ? 'error' : 'warning'" v-on="on">
                                        mdi-account-alert
                                    </v-icon>        
                                </template>

                                <span>{{item.status.descricao}}</span>
                            </v-tooltip>        
                            
                            <v-tooltip bottom v-else-if="item.status != null && item.status.codigoUnico == 'APROVADO'">
                                <template v-slot:activator="{ on }">
                                    <v-icon :color="item.dataGeracaoEmail == null ? 'warning' : 'success'" v-on="on">
                                        mdi-account-check
                                    </v-icon>        
                                </template>

                                <span v-show="item.dataGeracaoEmail == null">{{loginAprovado}}</span>
                                <span v-show="item.dataGeracaoEmail != null">{{loginEmailAprovado}}</span>
                            </v-tooltip>                                   
                            
                            <v-tooltip bottom v-else-if="item.status != null">
                                <template v-slot:activator="{ on }" v-if="item.status.codigoUnico == 'AG.LEIT.PPA'">
                                    <v-icon :color="item.status.passou24h ? 'error' : 'success'" v-on="on">
                                        mdi-account-search
                                    </v-icon>        
                                </template>

                                <template v-slot:activator="{ on }" v-else-if="item.status.codigoUnico == 'PROC.COL.PPA'">
                                    <v-icon :color="item.status.passou24h ? 'error' : 'success'" v-on="on">
                                        mdi-account-clock
                                    </v-icon>        
                                </template>                     
                                
                                <template v-slot:activator="{ on }" v-else-if="item.status.codigoUnico == 'ERRO.COL.PPA'">
                                    <v-icon color="error" v-on="on">
                                        mdi-account-remove
                                    </v-icon>        
                                </template>    
                                
                                <template v-slot:activator="{ on }" v-else-if="item.status.codigoUnico == 'ERRO.RET.PPA'">
                                    <v-icon color="error" v-on="on">
                                        mdi-account-question
                                    </v-icon>        
                                </template>                                     
                                
                                <template v-slot:activator="{ on }" v-else-if="item.status.codigoUnico == 'RETORNO.PPA'">
                                    <v-icon :color="item.status.passou24h ? 'error' : 'success'" v-on="on">
                                        mdi-account-arrow-left
                                    </v-icon>        
                                </template>            
                                
                                <template v-slot:activator="{ on }" v-else-if="item.status.codigoUnico == 'PROC.SAPSF'">
                                    <v-icon color="success" v-on="on">
                                        {{icons.mdiBadgeAccount}}
                                    </v-icon>   
                                </template>     
                                
                                <template v-slot:activator="{ on }" v-else-if="item.status.codigoUnico == 'ERRO.SAPSF'">
                                    <v-icon color="error" v-on="on">
                                        {{icons.mdiBadgeAccountAlert}}
                                    </v-icon>        
                                </template>                                    

                                <span v-if="item.status.descricaoErro == null">{{item.status.descricao}}</span>
                                <span v-else>{{`${item.status.descricao} - ${item.status.descricaoErro}`}}</span>
                            </v-tooltip>        
                        </template>                           

                        <template v-slot:[`item.acoes`]="{ item }">
                            <router-link :to="`/onboarding/colaborador/editar/${item.id}`" class="action">        
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" v-on="on">
                                            mdi-pencil
                                        </v-icon>        
                                    </template>

                                    <span>{{editar}}</span>
                                </v-tooltip>                           
                            </router-link>                               
                        </template>          

                        <template v-slot:no-data>{{nenhumColaboradorEncontrado}}</template>
                    </v-data-table>    
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import OnboardingConstantes from '@/constants/onboarding/parametrizacao'
import ParametrizacaoUtil from '../utils/parametrizacao'

import { mask }  from 'vue-the-mask'
import { mapGetters } from 'vuex'

import DocumentoMixin from '@/mixin/documento'
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'
import DatePickerRange from '@/components/material/DatePickerRange'
import Legenda from './Legenda.vue'

import ParametrizacaoOnboardingApi from '@/api/workspace/onboarding/parametrizacao'
import PreCadastroApi from '@/api/workspace/onboarding/precadastro'
import StatusIntegracaoApi from '@/api/workspace/onboarding/statusintegracao'

import { mdiBadgeAccount, mdiBadgeAccountAlert  } from '@mdi/js';

export default {
    mixins: [ DocumentoMixin, FormMixin, DateMixin ],  
    directives: { mask },  
    components: {
        "range-date-picker": DatePickerRange,
        "legenda": Legenda
    },   
    data () {
        return { 
            lista: {
                pais: [],
                yesOrNo: [],
                statusIntegracao: []
            },          
            rules:{
                pais: [
                    val => {
                        if((val || null) == null)
                            return this.cboPaisObrigatorio;

                        return true;
                    }
                ]                          
            },     
            icons:{
                mdiBadgeAccountAlert : mdiBadgeAccountAlert, 
                mdiBadgeAccount: mdiBadgeAccount
            },
            constantes: OnboardingConstantes,          
            indicadorAprovado: null,    
            pais: null,    
            paisGrid: null,
            paisPadraoUsuario: false,
            jobReqId: null,    
            documento: null, 
            primeiroNome: null,
            ultimoNome: null,
            dataSelecionada: [],
            resultado: [],
            listaStatus: null,
            colunas: [
                { text: this.jobReqId, align: 'right', value: 'jobReqId' },
                { text: this.$t("Views.Onboarding.Colaborador.Listar.documento"), align: 'right', value: 'documento' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.nome-completo'), align: 'left', value: 'nome' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.empresa'), align: 'left', value: 'empresa.nome' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.login'), align: 'left', value: 'login' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.email'), align: 'left', value: 'email' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.data-cadastro'), align: 'center', value: 'dataCadastro' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.data-admissao-real'), align: 'center', value: 'dataAdmissaoReal' },
                { text: this.$t('Views.Onboarding.Colaborador.Listar.status'), align: 'center', value: 'status' },
                { value: 'acoes', sortable: false },
            ],            
        }
    },
    computed: {  
        ...mapGetters("app", ["getUserCountry"]),
        title () {
            return this.$t('Views.Onboarding.Colaborador.Listar.form-title');            
        },          
        text () {
            return this.$t('Views.Onboarding.Colaborador.Listar.form-text');            
        },
        periodo(){
            return this.$t('Views.Onboarding.Colaborador.Listar.periodo');            
        },           
        selecionePeriodo(){
            return this.$t('Views.Onboarding.Colaborador.Listar.selecione-periodo');            
        },
        cboPais(){
            return this.$t('Views.Onboarding.Colaborador.Listar.pais');            
        },
        cboPaisSemDados(){
            return this.$t('Views.Onboarding.Colaborador.Listar.nenhum-pais-encontrado');            
        }, 
        cboPaisObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.Listar.selecione-pais');            
        }, 
        labelJobReqId(){
            return this.$t('Views.Onboarding.Colaborador.Listar.job-req-id');
        },                  
        labelPrimeiroNome () {
            return this.$t('Views.Onboarding.Colaborador.Listar.primeiro-nome');
        },                                  
        labelUltimoNome () {
            return this.$t('Views.Onboarding.Colaborador.Listar.ultimo-nome');
        },   
        status(){
            return this.$t('Views.Onboarding.Colaborador.Listar.status');
        },       
        editar(){
            return this.$t('Views.Onboarding.Colaborador.Listar.editar');
        },
        loginAprovado(){
            return this.$t('Views.Onboarding.Colaborador.Listar.indicador-login-aprovado');
        },        
        loginEmailAprovado(){
            return this.$t('Views.Onboarding.Colaborador.Listar.indicador-loginemail-aprovado');
        },                
        nenhumColaboradorEncontrado(){
            return this.$t('Views.Onboarding.Colaborador.Listar.nenhum-colaborador-encontrado');
        },   
        labelDocumento(){
            if(this.pais == null) return null;
            return this.$t(`Views.Onboarding.Colaborador.Listar.documento-${this.pais.codigoDuasLetrasSuccessFactors}`)
        },
        mascaraDocumento(){
            if(this.pais == null)
                return "";
            
            else{
                let mascara = this.retornarMascaraDocumentoPrincipal(this.pais);
                return mascara;
            }
        },
        paisComputed: {
            get(){
                if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
                    this.$set(this, "paisPadraoUsuario", true);
                    this.$set(this, "pais", this.getUserCountry);
                }

                return this.pais;
            },
            set(value){
                this.$set(this, "pais", value);
            }
        },
        codigoPais(){
            const pais = this.paisComputed;
            if(pais == null) return null;

            return pais.codigoDuasLetrasSuccessFactors;
        },
        exibirAdicionar(){
            if(this.showItem.insert != null){
                return this.showItem.insert;
            }
            return false;
        }                                                                                                                             
    },
    async created(){
        this.formUniqueCode = "FORM.ONCO.00001";
        this.privilegeUniqueCode = "SELC";

        this.$set(this.showItem, "insert", await this.hasAccess(this.formUniqueCode, "INSE"));
    },
    async mounted(){       
        const loading = this.showLoading();
        this.$set(this.lista, "yesOrNo", this.createListYesOrNo());

        this.$set(this, "dataSelecionada", this.createPeriodFromNowToPast(15, "days"));
        if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
            this.paisPadraoUsuario = true;
            this.$set(this, "pais", this.getUserCountry);
        }

        await this.listarPais();
        await this.listarStatusIntegracao();

        loading.close();                
    },
    methods:{  
        async listarPais(){
            const self = this;
            const paises = await ParametrizacaoOnboardingApi.listarPaises().catch(erro => self.showSnackbarError(erro.error));            

            if(paises.success) {
                self.$set(self.lista, "pais", this.$_.sortBy(paises.data, p => p.nome));
            }
            else {                        
                self.showSnackbarError(paises.error);
                throw new Error(paises.error[0].userMessage);
            }   
        },       
        async listarStatusIntegracao(){
            const self = this;
            const statusIntegracao = await StatusIntegracaoApi.listar().catch(erro => self.showSnackbarError(erro.error));            

            if(statusIntegracao.success) {
                self.$set(self.lista, "statusIntegracao", this.$_.sortBy(statusIntegracao.data, p => p.nome));
            }
            else {                        
                self.showSnackbarError(statusIntegracao.error);
                throw new Error(statusIntegracao.error[0].userMessage);
            }   
        },              
        async btnLimpar_OnClick(){
            this.$set(this, "dataSelecionada", []);
            this.$set(this, "resultado", []);
            this.$refs.form.reset();

            if(this.getUserCountry != null){
                this.$nextTick(() => {
                    this.$set(this, "paisPadraoUsuario", false);
                    this.$set(this, "pais", null);
                        
                });
            }         
        },         
        async btnPesquisar_OnClick(){
            const self = this;
            if(self.$refs.form.validate()){
                const loading = this.showLoading();
                const dataInicial = this.setFirstHourTime(self.dataSelecionada[0]);
                const dataFinal = this.setLastHourTime(self.dataSelecionada[1]);  

                self.resultado = [];
                self.paisGrid = self.pais;

                this.colunas = [
                    { text: self.$t('Views.Onboarding.Colaborador.Listar.job-req-id'), align: 'right', value: 'jobReqId' },
                    { text: self.$t(`Views.Onboarding.Colaborador.Listar.documento-${self.paisGrid.codigoDuasLetrasSuccessFactors}`), align: 'right', value: 'documento' },
                    { text: self.$t('Views.Onboarding.Colaborador.Listar.nome-completo'), align: 'left', value: 'nome' },
                    { text: self.$t('Views.Onboarding.Colaborador.Listar.empresa'), align: 'left', value: 'empresa' },
                    { text: self.$t('Views.Onboarding.Colaborador.Listar.login'), align: 'left', value: 'login' },
                    { text: self.$t('Views.Onboarding.Colaborador.Listar.email'), align: 'left', value: 'email' },
                    { text: self.$t('Views.Onboarding.Colaborador.Listar.data-cadastro'), align: 'center', value: 'dataCadastro' },
                    { text: this.$t('Views.Onboarding.Colaborador.Listar.data-admissao-real'), align: 'center', value: 'dataAdmissaoReal' },
                    { text: this.$t('Views.Onboarding.Colaborador.Listar.status'), align: 'center', value: 'status' },
                    { value: 'acoes', sortable: false },
                ];                   
                
                let onboarding = await PreCadastroApi.listarPorDataCadastro(
                    self.tranformDate2Epoch(dataInicial),
                    self.tranformDate2Epoch(dataFinal),
                    self.pais.id,
                    self.jobReqId,
                    self.documento,
                    self.primeiroNome,
                    self.ultimoNome,
                    this.listaStatus

                ).catch(erro => self.showSnackbarError(erro.error));    
                if(onboarding.success) {
                    const dtAtualMenos1dia = this.createPeriodFromNowToPast(1, 'days')[0];
                    self.resultado = onboarding.data.map(
                        colaborador => {
                            const primeiroNome = colaborador.atributo.filter(a => a.parametrizacaoOnboardingPaisAtributo.codigoUnico == OnboardingConstantes.dadosColaborador.PRIMEIRO_NOME);
                            const ultimoNome = colaborador.atributo.filter(a => a.parametrizacaoOnboardingPaisAtributo.codigoUnico == OnboardingConstantes.dadosColaborador.ULTIMO_NOME);
                            let codigo = ParametrizacaoUtil.getCodigoUnicoNaLista(colaborador, OnboardingConstantes.dadosColaborador.DOCUMENTO);

                            let documento = null;
                            let doc = colaborador.atributo.filter(a => a.parametrizacaoOnboardingPaisAtributo.codigoUnico == codigo);
                            if(doc.length > 0) documento = self.formatarDocumentoPrincipal(self.paisGrid, doc[0].valor);

                            let jobReqId = null;
                            const jobReq = colaborador.atributo.filter(a => a.parametrizacaoOnboardingPaisAtributo.codigoUnico == OnboardingConstantes.informacoesVaga.REQUISITION_ID);
                            if(jobReq.length > 0) jobReqId = jobReq[0].valor;

                            return {
                                id: colaborador.id, 
                                jobReqId: jobReqId,
                                documento: documento, 
                                nome: primeiroNome[0].valor + " " + ultimoNome[0].valor, 
                                empresa: colaborador.empresa.nome,
                                indicadorAprovado: colaborador.indicadorAprovado,
                                dataGeracaoEmail: colaborador.dataGeracaoEmail,
                                login: colaborador.login,
                                dataCadastro: colaborador.dataCadastro,
                                dataAdmissaoReal: colaborador.dataAdmissaoReal,
                                email: colaborador.email == null ? null : `${colaborador.email}@${colaborador.dominioEmail.descricao}`,
                                status: {
                                    codigoUnico: colaborador.statusIntegracao.statusIntegracao.codigoUnico,
                                    descricao: colaborador.statusIntegracao.statusIntegracao.descricao,
                                    descricaoErro: colaborador.statusIntegracao.descricaoErro, 
                                    dataCadastro: colaborador.statusIntegracao.dataCadastro,
                                    passou24h: colaborador.statusIntegracao.dataCadastro < dtAtualMenos1dia
                                }
                            };
                        }
                    );
                }
                else {                        
                    self.showSnackbarError(onboarding.error);
                    throw new Error(onboarding.error[0].userMessage);
                }                             

                loading.close();
            }
        }      
    }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
